const defaultColors = {
  azulTwo: '#1665d8',
  black: '#000000',
  black12: 'rgba(0, 0, 0, 0.12)',
  black32: 'rgba(0, 0, 0, 0.32)',
  blackSeven: '#101010',
  black80: 'rgba(0, 0, 0, 0.8)',
  blueGreyTwo: '#7b8fac',
  blueGreyThree: '#a3abbb',
  blueyGrey: '#8892a4',
  dark: '#1e2a3f',
  darkGreyBlueTwoSix: 'rgba(53, 78, 110, 0.6)',
  darkBlueFive: 'rgba(19, 69, 148, 0.5)',
  darkGray: '#5a7184',
  dusk: '#4c637d',
  mango: '#ffbc2f',
  pageNotFoundBottomBgColor: '#cad9f0',
  pageNotFoundInfoSectionBgColor: '#f6f6f8',
  pageNotFoundPointHyperlink: '#ff6b3c',
  pageNotFoundText: '#5e6977',
  pageNotFoundTopBgColor: '#f3f4f8',
  paleGrey: '#f6f7f9',
  paleGreyFour: '#fbfcfc',
  whiteTwo: 'rgba(255,255,255,0.2)',
  primaryColor: '#2196f3',
  pinkishOrange: '#ff6b3c',
  waterloo: '#828796',
  silver: '#c1c4c8',
  white50: 'rgba(255,255,255,0.5)',
  white: 'rgba(255,255,255,1)',
  cloudyBlue: '#c3cad9',
  navyBlue: '#002159',
  lipstick: '#cf1124',
  cerulean: '#0967d2',
  azulThree: '#1565d8',
  cement: '#9aa5b1',
  navyBlue1: '#016db9',
  charcoalGrey: '#323f4b',
  flickrBlue: '#1665d8',
  risinBlack: '#231F20',
  lightGray: '#CBD2D9',
  disabledLightGray: 'rgba(53, 78, 110, 0.6)',
  ceruleanBlue: '#006fe3',
  coolGrey: '#a3a7b3',
  opaceBlue: 'rgba(10, 122, 255, 0.08)',
  slate: '#475569',
  skyblue: '#0a7aff',
  battleshipGrey: '#6c7285',
  slateGray: '#64748B',
  lightDarkBlue: '#2563eb',
  malibu: '#60a5fa',
  lightBlueGrey: '#d0d8e9',
  zumthor: '#e5ecff',
  gullGray: '#94a3b8',
  pattensBlur: '#dbeafe',
  paleGrayFour: '#e4e7eb',
  royalBlue: '#367bde',
  lightViolet: '#EDE9FE',
  violet: '#7C3AED',
  cornflowerBlue: '#8B5CF6',
  fiord: '#475569',
  staleGray: '#64748B',
  pickledBluewood: '#334155',
  geyser: '#cbd5e1',
  lightCement: '#7b8794',
  lightRed400: '#F87171',
  mistyRose: '#ffe3e3',
  blackCoral: '#52606D',
  marineBlueThree: '#002f6e'
};
const styleGuideColors = {
  'base-black': '#000000',
  'base-white': '#ffffff',
  'light-blue-gray-50': '#f8fafc',
  'light-blue-gray-100': '#f1f5f9',
  'light-blue-gray-200': '#e2e8f0',
  'light-blue-gray-300': '#cbd5e1',
  'light-blue-gray-400': '#94a3b8',
  'light-blue-gray-500': '#64748b',
  'light-blue-gray-600': '#475569',
  'light-blue-gray-700': '#334155',
  'light-blue-gray-800': '#1e293b',
  'light-blue-gray-900': '#0f172a',
  'light-gray': '#6B7280',
  'light-red-50': '#fef2f2',
  'light-red-100': '#fee2e2',
  'light-red-200': '#fecaca',
  'light-red-300': '#fca5a5',
  'light-red-500': '#ef4444',
  'light-red-400': '#f87171',
  'light-red-600': '#dc2626',
  'light-red-700': '#b91c1c',
  'light-red-800': '#991b1b',
  'light-red-900': '#7f1d1d',
  'light-pink-50': '#fdf2f8',
  'light-pink-100': '#fce7f3',
  'light-pink-200': '#fbcfe8',
  'light-pink-300': '#f9a8d4',
  'light-pink-400': '#f472b6',
  'light-pink-500': '#ec4899',
  'light-pink-700': '#be185d',
  'light-pink-600': '#db2777',
  'light-pink-800': '#9d174d',
  'light-pink-900': '#831843',
  'light-fuchsia-50': '#fdf4ff',
  'light-fuchsia-100': '#fae8ff',
  'light-fuchsia-200': '#f5d0fe',
  'light-fuchsia-300': '#f0abfc',
  'light-fuchsia-400': '#e879f9',
  'light-fuchsia-500': '#d946ef',
  'light-fuchsia-600': '#c026d3',
  'light-fuchsia-700': '#a21caf',
  'light-fuchsia-800': '#86198f',
  'light-fuchsia-900': '#701a75',
  'light-purple-50': '#faf5ff',
  'light-purple-100': '#f3e8ff',
  'light-purple-200': '#e9d5ff',
  'light-purple-300': '#d8b4fe',
  'light-purple-400': '#c084fc',
  'light-purple-500': '#a855f7',
  'light-purple-600': '#9333ea',
  'light-purple-700': '#7e22ce',
  'light-purple-800': '#6b21a8',
  'light-purple-900': '#581c87',
  'light-violet-50': '#f5f3ff',
  'light-violet-100': '#ede9fe',
  'light-violet-200': '#ddd6fe',
  'light-violet-300': '#c4b5fd',
  'light-violet-400': '#a78bfa',
  'light-violet-500': '#8b5cf6',
  'light-violet-600': '#7c3aed',
  'light-violet-700': '#6d28d9',
  'light-violet-800': '#5b21b6',
  'light-violet-900': '#4c1d95',
  'light-indigo-50': '#eef2ff',
  'light-indigo-100': '#e0e7ff',
  'light-indigo-200': '#c7d2fe',
  'light-indigo-300': '#a5b4fc',
  'light-indigo-400': '#818cf8',
  'light-indigo-500': '#6366f1',
  'light-indigo-600': '#4f46e5',
  'light-indigo-700': '#4338ca',
  'light-indigo-800': '#3730a3',
  'light-indigo-900': '#312e81',
  'light-blue-50': '#eff6ff',
  'light-blue-100': '#dbeafe',
  'light-blue-200': '#bfdbfe',
  'light-blue-300': '#93c5fd',
  'light-blue-400': '#60a5fa',
  'light-blue-500': '#3b82f6',
  'light-blue-600': '#2563eb',
  'light-blue-700': '#1d4ed8',
  'light-blue-800': '#1e40af',
  'light-blue-900': '#1e3a8a',
  'light-cyan-50': '#ecfeff',
  'light-cyan-100': '#cffafe',
  'light-cyan-200': '#a5f3fc',
  'light-cyan-300': '#67e8f9',
  'light-cyan-400': '#22d3ee',
  'light-cyan-500': '#06b6d4',
  'light-cyan-600': '#0891b2',
  'light-cyan-700': '#0e7490',
  'light-cyan-800': '#155e75',
  'light-cyan-900': '#164e63',
  'light-teal-50': '#f0fdfa',
  'light-teal-100': '#ccfbf1',
  'light-teal-200': '#99f6e4',
  'light-teal-300': '#5eead4',
  'light-teal-400': '#2dd4bf',
  'light-teal-500': '#14b8a6',
  'light-teal-600': '#0d9488',
  'light-teal-700': '#0f766e',
  'light-teal-800': '#115e59',
  'light-teal-900': '#134e4a',
  'light-emerald-200': '#a7f3d0',
  'light-emerald-50': '#ecfdf5',
  'light-emerald-100': '#d1fae5',
  'light-emerald-500': '#10b981',
  'light-emerald-400': '#34d399',
  'light-emerald-300': '#6ee7b7',
  'light-emerald-600': '#059669',
  'light-emerald-700': '#047857',
  'light-emerald-800': '#065f46',
  'light-emerald-900': '#064e3b',
  'light-green-50': '#f0fdf4',
  'light-green-100': '#dcfce7',
  'light-green-200': '#bbf7d0',
  'light-green-300': '#86efac',
  'light-green-400': '#4ade80',
  'light-green-500': '#22c55e',
  'light-green-600': '#16a34a',
  'light-green-700': '#15803d',
  'light-green-800': '#166534',
  'light-green-900': '#14532d',
  'light-lime-50': '#f7fee7',
  'light-lime-100': '#ecfccb',
  'light-lime-200': '#d9f99d',
  'light-lime-300': '#bef264',
  'light-lime-400': '#a3e635',
  'light-lime-500': '#84cc16',
  'light-lime-700': '#4d7c0f',
  'light-lime-600': '#65a30d',
  'light-lime-800': '#3f6212',
  'light-lime-900': '#365314',
  'light-yellow-50': '#fefce8',
  'light-yellow-100': '#fef9c3',
  'light-yellow-200': '#fef08a',
  'light-yellow-300': '#fde047',
  'light-yellow-400': '#facc15',
  'light-yellow-500': '#eab308',
  'light-yellow-600': '#ca8a04',
  'light-yellow-700': '#a16207',
  'light-yellow-800': '#854d0e',
  'light-yellow-900': '#713f12',
  'light-amber-50': '#fffbeb',
  'light-amber-100': '#fef3c7',
  'light-amber-200': '#fde68a',
  'light-amber-350': '#ffcb4a',
  'light-amber-300': '#fcd34d',
  'light-amber-400': '#fbbf24',
  'light-amber-500': '#f59e0b',
  'light-amber-600': '#d97706',
  'light-amber-700': '#b45309',
  'light-amber-800': '#92400e',
  'light-amber-900': '#78350f',
  'light-orange-50': '#fff7ed',
  'light-orange-100': '#ffedd5',
  'light-orange-200': '#fed7aa',
  'light-orange-300': '#fdba74',
  'light-orange-400': '#fb923c',
  'light-orange-500': '#f97316',
  'light-orange-600': '#ea580c',
  'light-orange-700': '#c2410c',
  'light-orange-800': '#9a3412',
  'light-orange-900': '#7c2d12',
  'light-rose-50': '#fff1f2',
  'light-rose-100': '#ffe4e6',
  'light-rose-200': '#fecdd3',
  'light-rose-300': '#fda4af',
  'light-rose-400': '#fb7185',
  'light-rose-500': '#f43f5e',
  'light-rose-600': '#e11d48',
  'light-rose-700': '#be123c',
  'light-rose-800': '#9f1239',
  'light-rose-900': '#881337',
  'glass-white': 'rgba(255, 255, 255, 0.24)',
  'glass-black': 'rgba(0, 0, 0, 0.24)',
  ...defaultColors
};

export { styleGuideColors as colors };
